// Frontend mirror of the backend `isAllowedSowTransition` predicate
// (`backend/src/models/tracking.ts`). Re-exporting the rule from the
// backend would couple the bundles, so we keep a per-runtime copy with
// matching tests on both sides — same idiom the codebase uses for
// `currentSowValue` and the totalContractValue derivation.
//
// Source of truth: `backend/src/models/tracking.ts:684`. Drift would be
// caught by the matching transition test in
// `backend/tests/handlers/tracking.test.ts` and the test mirror that
// lives next to this file.
//
// Used by `SowFormFields` to disable invalid options in the Status
// dropdown so users cannot submit a transition the backend will reject.

import type { SowStatus } from "./index";

const SOW_ALLOWED_TRANSITIONS: Record<SowStatus, ReadonlySet<SowStatus>> = {
  draft: new Set<SowStatus>(["draft", "active", "cancelled"]),
  active: new Set<SowStatus>(["active", "completed", "cancelled"]),
  completed: new Set<SowStatus>(["completed"]),
  cancelled: new Set<SowStatus>(["cancelled"]),
};

export function isAllowedSowTransition(
  from: SowStatus,
  to: SowStatus,
): boolean {
  return SOW_ALLOWED_TRANSITIONS[from]?.has(to) ?? false;
}
